import { render, staticRenderFns } from "./RecommendOrganization.vue?vue&type=template&id=500bdd76&"
import script from "./RecommendOrganization.vue?vue&type=script&lang=ts&"
export * from "./RecommendOrganization.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('500bdd76')) {
      api.createRecord('500bdd76', component.options)
    } else {
      api.reload('500bdd76', component.options)
    }
    module.hot.accept("./RecommendOrganization.vue?vue&type=template&id=500bdd76&", function () {
      api.rerender('500bdd76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "common/src/feedback/RecommendOrganization.vue"
export default component.exports